module.exports = __webpack_public_path__ + "img/upload-form.82f0fb96.png";